<template>
    <div>
        <div class="comp-reset-num comp">
            <div class="bizcomp-reset-lpwd-title">
                找回密码
                <div v-show="selectedOption == null" class="lpwd-title-tip">
                    请选择找回密码方式:
                </div>
            </div>
            <div v-show="selectedOption == null" class="recoveryOptions-container">
                <div
                    v-for="(option, index) in recoveryOptions"
                    :key="index"
                    class="recovery-option selectedOption"
                    :class="{ selected: selectedOption === option.id }"
                    v-on:click="selectOption(option.id)"
                >
                    <p class="title">{{ option.title }}</p>
                    <p v-if="option.subtitle" class="subtitle">{{ option.subtitle }}</p>
                    <button v-on:click="selectOption(option.id)">找回密码 -></button>
                </div>
            </div>
            <retrieve-pwd
                v-show="selectedOption != null && pwdPattern"
                :way="way"
                :pwdrecoverytype="selectedOption"
                v-on:returnBack="selectedOption = null"
                v-on:reSelect="selectOption"
            />
            <reset-login-pwd
                v-show="selectedOption == 0 && !pwdPattern"
                :way="way"
                :pwd-pattern="pwdPattern"
                v-on:returnBack="selectedOption = null"
            />
        </div>
        <footer-questions
            v-if="$const.warmReminderDisplay"
            class="footer-questions"
            :common-question="commonQuestion"
            :warning-html="warningHtml"
        ></footer-questions>
    </div>
</template>
<script>
import userApi from "@/api/user";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import warningHtml from "@/constant/warning_html.js";
import retrievePwd from "@/components/acctInfo/retrievePwd.vue";
import resetLoginPwd from "@/components/acctInfo/resetPwdDc.vue";

export default {
    name: "PwdRecovery",
    components: {
        footerQuestions,
        retrievePwd,
        resetLoginPwd
    },
    props: {
        way: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            recoveryOptions: [
                { id: 0, title: "我在XXX直销开过户", subtitle: "已通过实名认证客户" },
                {
                    id: 1,
                    title: "我购买过XXX的基金产品",
                    subtitle: "通过代销机构购买过XXX的基金产品"
                },
                { id: 2, title: "我是手机注册客户", subtitle: "通过手机注册，还未进行实名认证" }
            ],
            selectedOption: null,
            warningHtml: "",
            commonQuestion: [],
            pwdPattern: null
        };
    },
    created() {
        this.warningHtml = warningHtml.warningHtml1;
        this.commonQuestion = this.$const.commonQuestion.commonQuestion1;
        const companyName = this.$cache.getCompanyInfoParam("10101001");

        // 配置的个性化文案信息
        const menuText = this.$cache.getParamValue("menu_text");
        if (menuText && menuText.forgetpwdtext) {
            const forgetpwdtext = menuText.forgetpwdtext;
            this.recoveryOptions.forEach((item) => {
                forgetpwdtext.forEach((subItem) => {
                    if (item.id == subItem.id) {
                        item.title = subItem.title;
                        item.subtitle = subItem.subtitle;
                    }
                });
            });
        }
        // 动态替换XXX占位符
        this.recoveryOptions = this.recoveryOptions.map((option) => ({
            id: option.id,
            title: option.title.replace(/XXX/g, companyName),
            subtitle: option.subtitle.replace(/XXX/g, companyName)
        }));

        // 是否屏蔽代销找回密码入口
        const accountInfo = this.$cache.getParamValue("account_info");
        if (accountInfo && accountInfo.resetccpwdenable == false) {
            this.recoveryOptions = this.recoveryOptions.filter((item) => {
                return item.id != 1;
            });
        }

        // 是否屏蔽注册找回密码入口
        if (accountInfo && accountInfo.resetregisterpwdenable == false) {
            this.recoveryOptions = this.recoveryOptions.filter((item) => {
                return item.id != 2;
            });
        }

        // 客户交易密码与登录密码一致的系统参数 24111501  此种情况下不能通过银行卡鉴权找回密码
        this.pwdPattern = this.$cache.getCompanyInfoParam("24111501") == "1";
    },
    methods: {
        selectOption(id) {
            this.selectedOption = id;
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";

.comp-reset-num {
    .bizcomp-reset-lpwd-title {
        height: 60px;
        padding: 17px 20px 22px;
        background: #ffffff;
        font-size: 20px;
        font-weight: 500;
        color: var(--color-text-primary);
        box-sizing: border-box;
        .lpwd-title-tip {
            font-size: 16px;
            font-weight: normal;
            color: var(--color-text-accent);
            margin-top: 30px;
        }
    }
    border: 1px solid var(--color-divided);
    margin-bottom: 20px;

    .recoveryOptions-container {
        display: flex;
        justify-content: space-between;
        margin-top: 50px;
        margin-bottom: 330px;
        padding: 0 20px;
        .recovery-option {
            border: 1px solid var(--color-text-weak);
            margin-bottom: 20px;
            padding: 20px;
            cursor: pointer;
            flex: 1;
            margin-right: 20px;
            max-width: 600px;
            display: flex;
            flex-direction: column;
            &.selected {
                border-color: var(--color-primary);
            }
            button {
                background-color: var(--color-primary);
                color: white;
                border: none;
                padding: 5px 20px;
                cursor: pointer;
                align-self: flex-start;
                margin-top: auto;
            }
            .title {
                font-size: 20px;
                font-weight: 500;
                color: var(--color-text-primary);
                min-height: 55px;
            }
            .subtitle {
                font-size: 14px;
                margin: 10px 0 15px 0;
                color: var(--color-text-accent);
                flex: 1;
            }
        }
    }
}
</style>
